/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCampfireFilled = createReactComponent("campfire-filled", "IconCampfireFilled", [
  [
    "path",
    {
      d: "M19.757 16.03a1 1 0 0 1 .597 1.905l-.111 .035l-16 4a1 1 0 0 1 -.597 -1.905l.111 -.035l16 -4z",
      fill: "currentColor",
      key: "svg-0",
      strokeWidth: "0"
    }
  ],
  [
    "path",
    {
      d: "M3.03 16.757a1 1 0 0 1 1.098 -.749l.115 .022l16 4a1 1 0 0 1 -.37 1.962l-.116 -.022l-16 -4a1 1 0 0 1 -.727 -1.213z",
      fill: "currentColor",
      key: "svg-1",
      strokeWidth: "0"
    }
  ],
  [
    "path",
    {
      d: "M13.553 2.106c-4.174 2.086 -6.553 5.358 -6.553 8.894a5 5 0 0 0 10 0c0 -1.047 -.188 -1.808 -.606 -2.705l-.169 -.345l-.33 -.647c-.621 -1.24 -.895 -2.338 -.895 -4.303a1 1 0 0 0 -1.447 -.894z",
      fill: "currentColor",
      key: "svg-2",
      strokeWidth: "0"
    }
  ]
]);

export { IconCampfireFilled as default };
//# sourceMappingURL=IconCampfireFilled.js.map
